// Packages
import * as React from 'react';

// Material UI
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import { black } from 'material-ui/styles/colors';

// Types
import { TestHistoryInfo, ProgramMemberInfo, TestResultCode } from './members.types';
import { Level } from '../programs/Types';

import { testResults } from './members.constants';

import { formatDate } from '../util/date-util';

const fieldStyles = {
  rootStyle: {
    cursor: 'text'
  },
  textStyle: {
    color: black
  },
  dividerStyle: {
    backgroundColor: 'rgb(0, 188, 212)'
  }
};

export interface Props {
  testHistory: TestHistoryInfo;
  programMembers: ProgramMemberInfo[];
  displayMode: string;
}

export interface States {
  testHistory: TestHistoryInfo;
}

class TestHistoriesDetailsComponent extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      testHistory: this.props.testHistory
    };

    this.onProgramSelect = this.onProgramSelect.bind(this);
    this.onLevelSelect = this.onLevelSelect.bind(this);
    this.onResultSelect = this.onResultSelect.bind(this);
    this.onTestDateChange = this.onTestDateChange.bind(this);
    this.getSelectableLevelsList = this.getSelectableLevelsList.bind(this);
    this.getSelectedProgramMember = this.getSelectedProgramMember.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      testHistory: nextProps.testHistory
    });  
  }

  render() {
    return (
      <div>
        {
          (this.props.displayMode === 'CREATE')
          ? <div className="row ma2 no-gutters">
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <SelectField
                    fullWidth={true}
                    floatingLabelText="Program"
                    value={this.state.testHistory.programId}
                    onChange={this.onProgramSelect}
                  >
                    {
                      this.props.programMembers.map((programMember, index) => {
                        return <MenuItem
                            key={index}
                            value={programMember.program.id}
                            primaryText={programMember.program.name}
                        />;
                      })
                    }
                  </SelectField>
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <SelectField
                    fullWidth={true}
                    floatingLabelText="Level"
                    value={this.state.testHistory.levelId}
                    onChange={this.onLevelSelect}
                  >
                    {
                      this.getSelectableLevelsList().map((level: Level, index) => {
                        return <MenuItem
                            key={index}
                            value={level.id}
                            primaryText={level.level}
                        />;
                      })
                    }
                  </SelectField>
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <SelectField
                    fullWidth={true}
                    floatingLabelText="Result"
                    value={this.state.testHistory.testResult}
                    onChange={this.onResultSelect}
                  >
                    {
                      testResults.map((testResult, index) => {
                        return <MenuItem
                            key={index}
                            value={testResult.code}
                            primaryText={testResult.name}
                        />;
                      })
                    }
                  </SelectField>
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <DatePicker
                    fullWidth={true}
                    className="w-100"
                    floatingLabelText="Test Date"
                    value={
                      (this.state.testHistory.testDate)
                      ? new Date(this.state.testHistory.testDate)
                      : new Date()
                    }
                    onChange={this.onTestDateChange}
                  />
                </div>
              </div>
            </div>
          : <div className="row ma2 no-gutters">
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <TextField
                    fullWidth={true}
                    floatingLabelText="Program"
                    floatingLabelFixed={true}
                    value={this.state.testHistory.programName}
                    disabled={true}
                    style={fieldStyles.rootStyle}
                    inputStyle={fieldStyles.textStyle}
                    floatingLabelStyle={fieldStyles.textStyle}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <TextField
                    fullWidth={true}
                    floatingLabelText="Level"
                    floatingLabelFixed={true}
                    value={this.state.testHistory.level}
                    disabled={true}
                    style={fieldStyles.rootStyle}
                    inputStyle={fieldStyles.textStyle}
                    floatingLabelStyle={fieldStyles.textStyle}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <TextField
                    fullWidth={true}
                    floatingLabelText="Result"
                    floatingLabelFixed={true}
                    value={this.state.testHistory.testResult}
                    disabled={true}
                    style={fieldStyles.rootStyle}
                    inputStyle={fieldStyles.textStyle}
                    floatingLabelStyle={fieldStyles.textStyle}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                  <TextField
                    fullWidth={true}
                    floatingLabelText="Test Date"
                    floatingLabelFixed={true}
                    value={formatDate(this.state.testHistory.testDate)}
                    disabled={true}
                    style={fieldStyles.rootStyle}
                    inputStyle={fieldStyles.textStyle}
                    floatingLabelStyle={fieldStyles.textStyle}
                  />
                </div>
              </div>
            </div>
        }
      </div>
    );
  }

  private onProgramSelect(event: React.TouchEvent<HTMLSelectElement>, index: number, value: number) {
    
    let selectedProgramMember = this.getSelectedProgramMember(value);

    let newTestHistory = this.state.testHistory;
    newTestHistory.programId = selectedProgramMember.program.id;
    newTestHistory.programName = selectedProgramMember.program.name;
    newTestHistory.levelId = selectedProgramMember.level.id;
    newTestHistory.level = selectedProgramMember.level.level;

    this.setState({
      testHistory: newTestHistory
    });
  }

  private onLevelSelect(event: React.TouchEvent<HTMLSelectElement>, index: number, value: number) {
  
    let selectedProgramId = (this.state.testHistory.programId)
    ? this.state.testHistory.programId
    : this.props.programMembers[0].program.id;
    let selectedProgramMember = this.getSelectedProgramMember(selectedProgramId);

    let selectedLevel = selectedProgramMember.program.levels.filter((level: Level) => {
      return level.id === value;
    })[0];

    let newTestHistory = this.state.testHistory;
    newTestHistory.levelId = selectedLevel.id;
    newTestHistory.level = selectedLevel.level;

    this.setState({
      testHistory: newTestHistory
    });
  }

  private onResultSelect(event: React.TouchEvent<HTMLSelectElement>, index: number, value: TestResultCode) {
    let newTestHistory = this.state.testHistory;
    newTestHistory.testResult = value;

    this.setState({
      testHistory: newTestHistory
    });
  }

  private onTestDateChange(event: React.FormEvent<HTMLInputElement>, date: Date) {
    const newTestDate = date.getTime();

    let newTestHistory = this.state.testHistory;
    newTestHistory.testDate = newTestDate;

    this.setState({
      testHistory: newTestHistory
    });
  }

  private getSelectableLevelsList() {

    let selectedProgramId = (this.state.testHistory.programId)
      ? this.state.testHistory.programId
      : this.props.programMembers[0].program.id;
    let selectedProgramMember = this.getSelectedProgramMember(selectedProgramId);

    return selectedProgramMember.program.levels;
  }

  private getSelectedProgramMember(selectedId: number) {
    return this.props.programMembers.filter((programMember: ProgramMemberInfo) => {
      return programMember.program.id === selectedId;
    })[0];
  }
}

export default TestHistoriesDetailsComponent;



// WEBPACK FOOTER //
// ./src/members/testHistories.details.component.tsx